export const styles = {
  bottomBarContainer: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "auto"
  }
};
